var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.css.articleRatingAbout},[_c('ArticleBoxes',{class:_vm.css.boxes,attrs:{"article":_vm.article,"in-tooltip":_vm.inTooltip,"should-disable-ad":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }